import { styled, css } from '@vebox/etui-system';
import { Component, createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends, d as _objectDestructuringEmpty, c as _defineProperty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import ClickOutside from '../ClickOutside/ClickOutside.js';

const ExtendedTooltipBubble = styled(Div)`
  position: absolute;
  min-width: 120px;
  max-width: 210px;
  z-index: 99;
  background-color: #fff;

  ${({
  theme
}) => css`
    font-family: ${theme.typography.fontFamily};
    font-size: ${theme.typography.fontSizeBase};
    font-weight: ${theme.typography.fontWeightRegular};
    line-height: ${theme.typography.lineHeightBase};
    box-shadow: ${theme.shadows[3]};
    padding: ${theme.spacing.sm}px;
  `};

  &::after {
    content: '';
    position: absolute;
  }

  ${({
  placement,
  gap,
  defaultPlacement
}) => placement === 'top' && defaultPlacement && css`
      bottom: ${gap ? `calc(${gap} + 100%)` : '100%'};
      left: 50%;
      padding-bottom: 9px;
      transform: translateX(-50%);
    `};

  ${({
  placement,
  gap,
  defaultPlacement
}) => placement === 'bottom' && defaultPlacement && css`
      top: ${gap ? `calc(${gap} + 100%)` : '100%'};
      left: 50%;
      padding-top: 9px;
      transform: translateX(-50%);
    `};

  ${({
  placement,
  gap,
  defaultPlacement
}) => placement === 'left' && defaultPlacement && css`
      top: 50%;
      right: ${gap ? `calc(${gap} + 100%)` : '100%'};
      padding-right: 9px;
      transform: translateY(-50%);
    `};

  ${({
  placement,
  gap,
  defaultPlacement
}) => placement === 'right' && defaultPlacement && css`
      top: 50%;
      left: ${gap ? `calc(${gap} + 100%)` : '100%'};
      padding-left: 9px;
      transform: translateY(-50%);
    `};
`;

const _excluded = ["theme", "warning"],
  _excluded2 = ["theme"];
const ExtendedTooltipMessage = styled(Div).attrs(_ref => {
  let {
      theme,
      warning
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    color: theme.palette.primary.main,
    bg: theme.palette.common.white,
    borderRadius: '2px',
    p: `${theme.spacing.sm}px`,
    fontSize: theme.typography.fontSizeSmall,
    width: warning && '200%',
    ml: warning && '50px'
  }, props);
})`
  font-weight: normal;
  line-height: 1.25;
  word-break: normal;
`;
const Title = styled(Div).attrs(_ref2 => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  return _objectSpread2({
    fontWeight: 600,
    fontSize: '14px'
  }, props);
})``;
const Separator = styled(Div).attrs(_ref3 => {
  let {
      theme
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded2);
  return _objectSpread2({
    width: '100%',
    height: '1px',
    m: '8px 0',
    bg: theme.palette.common.bg
  }, props);
})``;
const Content = styled(Div).attrs(_ref4 => {
  let props = _extends({}, (_objectDestructuringEmpty(_ref4), _ref4));
  return _objectSpread2({}, props);
})``;

class ExtendedTooltip extends Component {
  constructor(props) {
    super(props);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
    this.state = {
      isOpen: false
    };
  }
  hideTooltip() {
    if (!this.state.isOpen) return;
    this.setState({
      isOpen: false
    });
  }
  showTooltip() {
    if (this.state.isOpen) return;
    this.setState({
      isOpen: true
    });
  }
  render() {
    const {
      styles,
      placement,
      disableToolTip,
      displayTooltip,
      title,
      content,
      showDivider,
      defaultPlacement,
      children
    } = this.props;
    const {
      isOpen
    } = this.state;
    const onMouseOverProps = _objectSpread2({
      onFocus: disableToolTip ? this.hideTooltip : this.showTooltip,
      onMouseOver: disableToolTip ? this.hideTooltip : this.showTooltip,
      onTouchStart: this.showTooltip,
      onMouseLeave: this.hideTooltip
    }, styles.wrapper);
    const bubbleProps = displayTooltip ? onMouseOverProps : {};
    return /*#__PURE__*/createElement(ClickOutside, {
      onClickOutside: this.hideTooltip,
      enableOnMouseLeave: true,
      styles: {
        root: _objectSpread2({
          position: 'relative',
          display: 'inline-block'
        }, styles.root)
      }
    }, isOpen || displayTooltip ? /*#__PURE__*/createElement(ExtendedTooltipBubble, _extends({
      placement: placement,
      defaultPlacement: defaultPlacement
    }, bubbleProps), /*#__PURE__*/createElement(Title, styles.title, title), showDivider && /*#__PURE__*/createElement(Separator, styles.separator), /*#__PURE__*/createElement(Content, styles.content, content)) : null, children && /*#__PURE__*/createElement(Div, onMouseOverProps, children));
  }
}
_defineProperty(ExtendedTooltip, "defaultProps", {
  title: '',
  placement: 'bottom',
  disableToolTip: false,
  displayTooltip: false,
  defaultPlacement: true,
  showDivider: true,
  styles: {
    root: {},
    wrapper: {},
    title: {},
    content: {},
    separator: {}
  }
});

export default ExtendedTooltip;
